const TOOLTIP_DELAY = 5000;

const selectors = {
  tooltip: {
    container: '[data-kenect-text-tooltip]',
    closeButton: '[data-kenect-text-tooltip-close]',
    textContainer: '[data-kenect-text-tooltip-text]',
  },
  trigger: {
    container: '[data-kenect-text-trigger]',
  },
};

const settings = {
  tooltipText: {
    desktop: 'Hi there, have a question? Send us a text!',
    mobile: 'Have a question? Send us a text!',
  },
};

export { TOOLTIP_DELAY, selectors, settings };
